export default function provisionalModuleDataBasedOnLanguage(language) {
  if (!language || language === "nb-NO" || language === "no-NO") {
    return {
      searchTitle: "Vurderer du søket ditt på nytt?",
      searchComing: "Velg ankomst og avreisedato",
      formTitleActivities: "Når kommer du?",
      searchWho: "Hvem kommer?",
      editSearch: "Rediger søk",
      sortBy: "Sorter etter",
      listView: "Listevisning",
      mapView: "Kartvisning",
      from: "fra",
      average: "snitt/natt",
      searching: "Søker...",
      select: "Velg",
      foundResults: "Fant [results] resultater",
      fill_lodging: "Velg datoer og gjester",
      select_lodging: "Velg et overnattingssted",
      view_lodging: "Vis rom",
      view_activity: "Se aktiviteter",
      view_restaurant: "Reserver bord",
     "view_ticket": "Se billetter",
     "view_rental": "Se skiutleie",
      fill_activities: "Velg dato",
      select_activities: "Velg en aktivitet",
      filtersModalTitleLabel: "Filtre",
      filtersModalButtonLabel: "Velg filter",
      buttonAddLabel: "Legg til",
      filterAmenitiesTitle: "Filterfasiliteter",
      filterDatesTitle: "Filtrer datoer",
      filterNameTitle: "Filternavn",
      searchInputPlaceholder: "Søk etter navn",
      ctaLabel: "Vis",
      startDatePlaceholder: "Sjekk inn",
      endDatePlaceholder: "Sjekk ut",
      buttonMapLabel: "Kart",
      buttonFiltersLabel: "Filtre",
      checkinLabelPlaceholder: "Sjekk inn",
      checkoutLabelPlaceholder: "Sjekk ut",
      sortModalButtonLabel: "Velg sortering",
      participantsPlaceholder: "Antall deltakere",
      timePlaceholder: "Tidslukevelger",
      personLabel: "person",
      optionalServices: "Valgfrie tjenester",
      optionalServicesSubtitle: "Velg en av disse flotte tjenestene for å forbedre reisen din",
      skip: "Hoppe over",
      addServices: "Legg til tjenester",
      changeSelection: "Endre valg",
      nextSelection: "Neste valg",
      addPackage: "Legg til konfigurert pakke i handlekurven",
      adding: "Legger til...",
      guestLabel: "Gjest",
      guestsLabel: "Gjester",
      descriptionLabel: "Beskrivelse",
      locationLabel: "Plassering",
      policiesLabel: "Retningslinjer",
      closeButton: "Lukk",
      showMoreButtonLabel: "Vis mer",
      showLessButtonLabel: "Vis mindre",
      showAllButtonLabel: "Vis alle",
      daysLabel: "dager",
      dayLabel: "dag",
      errorSearching: "Det oppsto en feil ved forsøk på å hente produktene fra denne siden, prøv et nytt søk.",
      addToCart: "Legg i handlekurv",
      addingToCart: "Legger til...",
      goToCart: "Gå til handlekurven",
      addedToCart: "har blitt lagt til i handlekurven din.",
      packagePrice: "Pakkepris",
      vatIncluded: "MVA inkludert",
      sortPriceAlphabeticalHighToLow: "Alfabetisk (Z - A)",
      sortPriceAlphabeticalLowToHigh: "Alfabetisk (A - Z)",
      sortFeatured: "Featured",
      sortPriceLowToHigh: "Pris (lav til høy)",
      sortPiceHighToLow: "Pris (høy til lav)",
      buttonValidateRoom: "Valider {roomNumber} av {roomsTotal} rom",
      labelAddToCard: "og legg i handlekurven",
      roomSummaryFirstRow: "{step}/{totalSteps} Velg ditt rom {currentRoom}",
      roomSummarySecondRow: "Priser for {persons} personer og {nights} netter",
      room: "Rom",
      rooms: "rom",
      addRoom: "Legg til et annet rom",
      addMoreActivities: "Legg til flere aktiviteter",
      unavailableLabel: "Ikke tilgjengelig på valgte datoer",
      errorAdding: "Noe gikk galt under forsøket på å legge til dette produktet i handlekurven. Prøv igjen senere.",
      selectAmount: "Velg antall",
      each: "Per stk.",
      ticketsAdded: "Du har valgt [quantity] av de [max] nødvendige produkter.",
      requirements: {
        photo: {
          photoButton: "Last opp bilde",
          photoDescription1: "Passformat kreves",
          photoDescription2: "Kun JPG, PNG og WebP filer godtas",
          photoDescription3: "(Maks 8 MB filstørrelse)",
        },
        keycard: {
          keycardButtonLabel: "Keycard",
          keycardModalTitle: "Keycard",
          keycardModalDescription: "For å kunne passere svingkorsene før heisene, må heiskortet ditt lastes på et gyldig og kompatibelt nøkkelkort. Oppbevar nøkkelkortet i en trygg lomme på venstre side av kroppen. NB! Det er viktig at du ikke har flere nøkkelkort i samme lomme / på samme side, for da vil signalene oppfattes feil av leseren og du vil ikke klare å passere svingkorken.",
          keycardModalButton1: "Jeg har allerede et nøkkelkort. Må være av en nyere type og begynne med sifrene 01 eller 30",
          keycardModalButton1Warning: "NB! Må være av en nyere type og begynne med sifrene 01 eller 30",
          keycardModalButton2: "Jeg trenger et nytt nøkkelkort",
          keycardModalReloadTitle: "Tast inn nøkkelkortnummeret",
          keycardModalReloadDescription1: "Nummeret finner du printet på baksiden av keycardet. Skriv det inn nøyaktig slik det er printet, UTEN mellomrom, men MED bindestrek. NB! Må være av nyere type og starte med sifrene 01 eller 30",
          keycardModalReloadDescription2: "NB! Må være av nyere type og starte med sifrene 01 eller 30",
          keycardModalReloadCancel: "Avbryt",
          keycardModalReloadConfirm: "Bekreft nummeret",
          keycardExampleNumber: "01-1614 5555-6666 7777 8888-9",
          keycardExampleText: "Nøkkelkortnummer",
          keycardModalLoading: "Validerer nøkkelkort...",
          keycardModalNewDescription: "Nøkkelkort lagt til heiskortet",
          keycardModalNewButton: "Ok"
        },
        error: "Feil",
      },
      passholders: {
        newPassholder: "Legg inn ny bruker",
        selectStoredPassholder: "Velg en lagret bruker",
        nextText: "Neste",
        saveText: 'Lagre',
      },
      linkToCart: "/handlekurv",
      availabilityStatus: {
        available: "Available",
        fewLeft: "Few left",
        almostFull: "Almost full",
      },
    }
  }

  if (language === "en-US" || language === "de-DE") {
    return {
      searchTitle: "Rethinking your search?",
      searchComing: "Choose Check-In and Check-Out date",
      formTitleActivities: "When are you coming?",
      searchWho: "Who is coming?",
      editSearch: "Edit search",
      sortBy: "Sort by",
      listView: "List View",
      mapView: "Map View",
      from: "from",
      average: "avg/night",
      searching: "Searching...",
      select: "Select",
      foundResults: "Found [results] results",
      fill_lodging: "Select dates and guests",
      select_lodging: "Select a lodging",
      view_lodging: "View",
      view_activity: "View activities",
      view_restaurant: "Reserve table",
      "view_ticket": "View tickets",
      "view_rental": "View rentals",
      fill_activities: "Select date",
      select_activities: "Select an activity",
      filtersModalTitleLabel: "Filters",
      filtersModalButtonLabel: "Select filter",
      buttonAddLabel: "Add",
      filterAmenitiesTitle: "Filter Amenities",
      filterDatesTitle: "Filter Dates",
      filterNameTitle: "Filter Name",
      searchInputPlaceholder: "Search by name",
      ctaLabel: "View",
      startDatePlaceholder: "Check in",
      endDatePlaceholder: "Check out",
      buttonMapLabel: "Map",
      buttonFiltersLabel: "Filters",
      checkinLabelPlaceholder: "Check in",
      checkoutLabelPlaceholder: "Check out",
      sortModalButtonLabel: "Select sorting",
      participantsPlaceholder: "Number of participants",
      timePlaceholder: "Time slot picker",
      personLabel: "person",
      optionalServices: "Optional Services",
      optionalServicesSubtitle: "Choose any of this great services to enhance you trip",
      skip: "Skip",
      addServices: "Add services",
      changeSelection: "Change selection",
      nextSelection: "Next selection",
      addPackage: "Add configured package to cart",
      adding: "Adding...",
      guestLabel: "Guest",
      guestsLabel: "Guests",
      descriptionLabel: "Description",
      locationLabel: "Location",
      policiesLabel: "Policies",
      closeButton: "Close",
      showMoreButtonLabel: "Show more",
      showLessButtonLabel: "Show less",
      showAllButtonLabel: "Show all",
      daysLabel: "days",
      dayLabel: "day",
      errorSearching: "There was an error attempting to retrieve the products of this page, please try another search.",
      addToCart: "Add to cart",
      addingToCart: "Adding...",
      goToCart: "Go to cart",
      addedToCart: "has been added to your cart",
      packagePrice: "Package price",
      vatIncluded: "VAT included",
      sortPriceAlphabeticalHighToLow: "Alphabetic (Z - A)",
      sortPriceAlphabeticalLowToHigh: "Alphabetic (A - Z)",
      sortFeatured: "Featured",
      sortPriceLowToHigh: "Price (low to high)",
      sortPiceHighToLow: "Price (high to low)",
      buttonValidateRoom: "Validate room {roomNumber} of {roomsTotal}",
      labelAddToCard: "and add to cart",
      roomSummaryFirstRow: "{step}/{totalSteps} Choose your room {currentRoom}",
      roomSummarySecondRow: "Prices for {persons} persons and {nights} nights",
      room: "Room",
      rooms: "rooms",
      addRoom: "Add another room",
      addMoreActivities: "Add more actvities",
      unavailableLabel: "Not available on selected dates",
      errorAdding: "Something went wrong trying to add this product to the cart, please try again later.",
      selectAmount: "Select amount",
      each: "each.",
      ticketsAdded: "You have selected [quantity] out of the [max] required products",
      requirements: {
        photo: {
          photoButton: "Upload photo",
          photoDescription1: "Passport format required",
          photoDescription2: "Only JPG, PNG and WebP files are accepted",
          photoDescription3: "(Maximum 8 MB file size)",
        },
        keycard: {
          keycardButtonLabel: "Keycard",
          keycardModalTitle: "Keycard",
          keycardModalDescription: "In order to pass the turnstiles before the lifts, your lift card must be loaded onto a valid and compatible key card. Store the key card in a secure pocket on the left side of the body. NB! It is important that you do not have several key cards in the same pocket / on the same side, because then the signals will be perceived incorrectly by the reader and you will not be able to pass the traffic jam.",
          keycardModalButton1: "I already have a key card. Must be of a newer type and start with the digits 01 or 30",
          keycardModalButton1Warning: "NB! Must be of a newer type and start with the digits 01 or 30",
          keycardModalButton2: "I need a new key card",
          keycardModalReloadTitle: "Enter the keycard number",
          keycardModalReloadDescription1: "You will find the number printed on the back of the keycard. Enter it exactly as it is printed, WITHOUT spaces, but WITH hyphens. NB! Must be of a newer type and start with the digits 01 or 30",
          keycardModalReloadDescription2: " NB! Must be of a newer type and start with the digits 01 or 30",
          keycardModalReloadCancel: "Cancel",
          keycardModalReloadConfirm: "Confirm the number",
          keycardExampleNumber: "01-1614 5555-6666 7777 8888-9",
          keycardExampleText: "Keycard number",
          keycardModalLoading: "Validating keycard...",
          keycardModalNewDescription: "Key card added to the lift card",
          keycardModalNewButton: "Ok"
        },
        error: "Error",
      },
      passholders: {
        newPassholder: "Enter new user",
        selectStoredPassholder: "Select a saved user",
        nextText: "Next",
        saveText: 'Save',
      },
      linkToCart: "/en-US/shopping-cart",
      availabilityStatus: {
        available: "Available",
        fewLeft: "Few left",
        almostFull: "Almost full",
      },
    }
  }

  if (language === "fr-FR") {
    return {
      searchTitle: "Vous repensez votre recherche ?",
      searchComing: "Choisissez les dates d'arrivée et de départ",
      formTitleActivities: "Quand arrivez-vous ?",
      searchWho: "Qui vient ?",
      editSearch: "Modifier la recherche",
      sortBy: "Trier par",
      listView: "Vue liste",
      mapView: "Vue carte",
      from: "à partir de",
      average: "moy/nuit",
      searching: "Recherche...",
      select: "Sélectionner",
      foundResults: "Trouvé [results] résultats",
      fill_lodging: "Sélectionnez les dates et les invités",
      select_lodging: "Sélectionnez un hébergement",
      view_lodging: "Voir",
      view_activity: "Voir les activités",
      view_restaurant: "Réserver une table",
      "view_ticket": "Voir les billets",
      "view_rental": "Voir les locations",
      fill_activities: "Sélectionner une date",
      select_activities: "Sélectionner une activité",
      filtersModalTitleLabel: "Filtres",
      filtersModalButtonLabel: "Sélectionner un filtre",
      buttonAddLabel: "Ajouter",
      filterAmenitiesTitle: "Filtrer les équipements",
      filterDatesTitle: "Filtrer les dates",
      filterNameTitle: "Filtrer par nom",
      searchInputPlaceholder: "Rechercher par nom",
      ctaLabel: "Voir",
      startDatePlaceholder: "Arrivée",
      endDatePlaceholder: "Départ",
      buttonMapLabel: "Carte",
      buttonFiltersLabel: "Filtres",
      checkinLabelPlaceholder: "Arrivée",
      checkoutLabelPlaceholder: "Départ",
      sortModalButtonLabel: "Sélectionner le tri",
      participantsPlaceholder: "Nombre de participants",
      timePlaceholder: "Sélecteur de créneau horaire",
      personLabel: "personne",
      optionalServices: "Services optionnels",
      optionalServicesSubtitle: "Choisissez l'un de ces excellents services pour améliorer votre voyage",
      skip: "Passer",
      addServices: "Ajouter des services",
      changeSelection: "Modifier la sélection",
      nextSelection: "Sélection suivante",
      addPackage: "Ajouter le forfait configuré au panier",
      adding: "Ajout en cours...",
      guestLabel: "Invité",
      guestsLabel: "Invités",
      descriptionLabel: "Description",
      locationLabel: "Emplacement",
      policiesLabel: "Politiques",
      closeButton: "Fermer",
      showMoreButtonLabel: "Voir plus",
      showLessButtonLabel: "Voir moins",
      showAllButtonLabel: "Voir tout",
      daysLabel: "jours",
      dayLabel: "jour",
      errorSearching: "Une erreur s'est produite lors de la tentative de récupération des produits de cette page, veuillez essayer une autre recherche.",
      addToCart: "Ajouter au panier",
      addingToCart: "Ajout en cours...",
      goToCart: "Aller au panier",
      addedToCart: "a été ajouté à votre panier",
      packagePrice: "Prix du forfait",
      vatIncluded: "TVA incluse",
      sortPriceAlphabeticalHighToLow: "Alphabétique (Z - A)",
      sortPriceAlphabeticalLowToHigh: "Alphabétique (A - Z)",
      sortFeatured: "En vedette",
      sortPriceLowToHigh: "Prix (croissant)",
      sortPiceHighToLow: "Prix (décroissant)",
      buttonValidateRoom: "Valider la chambre {roomNumber} sur {roomsTotal}",
      labelAddToCard: "et ajouter au panier",
      roomSummaryFirstRow: "{step}/{totalSteps} Choisissez votre chambre {currentRoom}",
      roomSummarySecondRow: "Prix pour {persons} personnes et {nights} nuits",
      room: "Chambre",
      rooms: "chambres",
      addRoom: "Ajouter une autre chambre",
      addMoreActivities: "Ajouter plus d'activités",
      unavailableLabel: "Non disponible aux dates sélectionnées",
      errorAdding: "Une erreur s'est produite lors de la tentative d'ajout de ce produit au panier, veuillez réessayer plus tard.",
      selectAmount: "Sélectionner la quantité",
      each: "chacun.",
      ticketsAdded: "Vous avez sélectionné [quantity] sur les [max] produits requis",
      requirements: {
        photo: {
          photoButton: "Télécharger une photo",
          photoDescription1: "Format passeport requis",
          photoDescription2: "Seuls les fichiers JPG, PNG et WebP sont acceptés",
          photoDescription3: "(Taille de fichier maximale 8 MB)",
        },
        keycard: {
          keycardButtonLabel: "Carte-clé",
          keycardModalTitle: "Carte-clé",
          keycardModalDescription: "Pour pouvoir passer les tourniquets avant les remontées mécaniques, votre carte de remontée doit être chargée sur une carte-clé valide et compatible. Conservez la carte-clé dans une poche sécurisée sur le côté gauche du corps. NB ! Il est important de ne pas avoir plusieurs cartes-clés dans la même poche / du même côté, car les signaux seront alors mal perçus par le lecteur et vous ne pourrez pas passer le tourniquet.",
          keycardModalButton1: "J'ai déjà une carte-clé. Doit être d'un type plus récent et commencer par les chiffres 01 ou 30",
          keycardModalButton1Warning: "NB ! Doit être d'un type plus récent et commencer par les chiffres 01 ou 30",
          keycardModalButton2: "J'ai besoin d'une nouvelle carte-clé",
          keycardModalReloadTitle: "Entrez le numéro de la carte-clé",
          keycardModalReloadDescription1: "Vous trouverez le numéro imprimé au dos de la carte-clé. Entrez-le exactement comme il est imprimé, SANS espaces, mais AVEC des tirets. NB ! Doit être d'un type plus récent et commencer par les chiffres 01 ou 30",
          keycardModalReloadDescription2: "NB ! Doit être d'un type plus récent et commencer par les chiffres 01 ou 30",
          keycardModalReloadCancel: "Annuler",
          keycardModalReloadConfirm: "Confirmer le numéro",
          keycardExampleNumber: "01-1614 5555-6666 7777 8888-9",
          keycardExampleText: "Numéro de carte-clé",
          keycardModalLoading: "Validation de la carte-clé...",
          keycardModalNewDescription: "Carte-clé ajoutée à la carte de remontée",
          keycardModalNewButton: "Ok"
        },
        error: "Erreur",
      },
      passholders: {
        newPassholder: "Saisir un nouvel utilisateur",
        selectStoredPassholder: "Sélectionner un utilisateur sauvegardé",
        nextText: "Suivant",
        saveText: 'Enregistrer',
      },
      linkToCart: "/fr-FR/panier",
      availabilityStatus: {
        available: "Disponible",
        fewLeft: "Quelques places",
        almostFull: "Presque complet",
      },
    }
  }

  return {
    searchTitle: "Rethinking your search?",
    searchComing: "Choose Check-In and Check-Out date",
    formTitleActivities: "When are you coming?",
    searchWho: "Who is coming?",
    editSearch: "Edit search",
    sortBy: "Sort by",
    listView: "List View",
    mapView: "Map View",
    from: "from",
    average: "avg/night",
    searching: "Searching...",
    select: "Select",
    foundResults: "Found [results] results",
    fill_lodging: "Select dates and guests",
    select_lodging: "Select a lodging",
    view_lodging: "View",
    view_activity: "View activities",
    view_restaurant: "Reserve table",
    "view_ticket": "View tickets",
    "view_rental": "View rentals",
    fill_activities: "Select date",
    select_activities: "Select an activity",
    filtersModalTitleLabel: "Filters",
    filtersModalButtonLabel: "Select filter",
    buttonAddLabel: "Add",
    filterAmenitiesTitle: "Filter Amenities",
    filterDatesTitle: "Filter Dates",
    filterNameTitle: "Filter Name",
    searchInputPlaceholder: "Search by name",
    ctaLabel: "View",
    startDatePlaceholder: "Check in",
    endDatePlaceholder: "Check out",
    buttonMapLabel: "Map",
    buttonFiltersLabel: "Filters",
    checkinLabelPlaceholder: "Check in",
    checkoutLabelPlaceholder: "Check out",
    sortModalButtonLabel: "Select sorting",
    participantsPlaceholder: "Number of participants",
    timePlaceholder: "Time slot picker",
    personLabel: "person",
    optionalServices: "Optional Services",
    optionalServicesSubtitle: "Choose any of this great services to enhance you trip",
    skip: "Skip",
    addServices: "Add services",
    changeSelection: "Change selection",
    nextSelection: "Next selection",
    addPackage: "Add configured package to cart",
    adding: "Adding...",
    guestLabel: "Guest",
    guestsLabel: "Guests",
    descriptionLabel: "Description",
    locationLabel: "Location",
    policiesLabel: "Policies",
    closeButton: "Close",
    showMoreButtonLabel: "Show more",
    showLessButtonLabel: "Show less",
    showAllButtonLabel: "Show all",
    daysLabel: "days",
    dayLabel: "day",
    errorSearching: "There was an error attempting to retrieve the products of this page, please try another search.",
    addToCart: "Add to cart",
    addingToCart: "Adding...",
    goToCart: "Go to cart",
    addedToCart: "has been added to your cart",
    packagePrice: "Package price",
    vatIncluded: "VAT included",
    sortPriceAlphabeticalHighToLow: "Alphabetic (Z - A)",
    sortPriceAlphabeticalLowToHigh: "Alphabetic (A - Z)",
    sortFeatured: "Featured",
    sortPriceLowToHigh: "Price (low to high)",
    sortPiceHighToLow: "Price (high to low)",
    buttonValidateRoom: "Validate room {roomNumber} of {roomsTotal}",
    labelAddToCard: "and add to cart",
    roomSummaryFirstRow: "{step}/{totalSteps} Choose your room {currentRoom}",
    roomSummarySecondRow: "Prices for {persons} persons and {nights} nights",
    room: "Room",
    rooms: "rooms",
    addRoom: "Add another room",
    addMoreActivities: "Add more actvities",
    unavailableLabel: "Not available on selected dates",
    errorAdding: "Something went wrong trying to add this product to the cart, please try again later.",
    selectAmount: "Select amount",
    each: "each.",
    ticketsAdded: "You have selected [quantity] out of the [max] required products",
    requirements: {
      photo: {
        photoButton: "Upload photo",
        photoDescription1: "Passport format required",
        photoDescription2: "Only JPG, PNG and WebP files are accepted",
        photoDescription3: "(Maximum 8 MB file size)",
      },
      keycard: {
        keycardButtonLabel: "Keycard",
        keycardModalTitle: "Keycard",
        keycardModalDescription: "In order to pass the turnstiles before the lifts, your lift card must be loaded onto a valid and compatible key card. Store the key card in a secure pocket on the left side of the body. NB! It is important that you do not have several key cards in the same pocket / on the same side, because then the signals will be perceived incorrectly by the reader and you will not be able to pass the traffic jam.",
        keycardModalButton1: "I already have a key card. Must be of a newer type and start with the digits 01 or 30",
        keycardModalButton1Warning: "NB! Must be of a newer type and start with the digits 01 or 30",
        keycardModalButton2: "I need a new key card",
        keycardModalReloadTitle: "Enter the keycard number",
        keycardModalReloadDescription1: "You will find the number printed on the back of the keycard. Enter it exactly as it is printed, WITHOUT spaces, but WITH hyphens. NB! Must be of a newer type and start with the digits 01 or 30",
        keycardModalReloadDescription2: " NB! Must be of a newer type and start with the digits 01 or 30",
        keycardModalReloadCancel: "Cancel",
        keycardModalReloadConfirm: "Confirm the number",
        keycardExampleNumber: "01-1614 5555-6666 7777 8888-9",
        keycardExampleText: "Keycard number",
        keycardModalLoading: "Validating keycard...",
        keycardModalNewDescription: "Key card added to the lift card",
        keycardModalNewButton: "Ok"
      },
      error: "Error",
    },
    passholders: {
      newPassholder: "Enter new user",
      selectStoredPassholder: "Select a saved user",
      nextText: "Next",
      saveText: 'Save',
    },
    linkToCart: "/en-US/shopping-cart",
    availabilityStatus: {
      available: "Available",
      fewLeft: "Few left",
      almostFull: "Almost full",
    },
  }
}